import { fill } from "lodash";
import React from "react";

const bars = [
  { x: -4, height: 60, y: 30, dur: "0.6s" },
  { x: 26, height: 75, y: 22.5, dur: "0.45s" },
  { x: 58, height: 90, y: 15, dur: "0.65s" },
  { x: 90, height: 75, y: 22.5, dur: "0.5s" },
  { x: 122, height: 60, y: 30, dur: "0.6s" },
];

const Visualizer = ({ animating, connected }) => {
  let fillColor = "url(#aiDisconnected)";

  if (connected) fillColor = "url(#aiConnected)";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg
          width="80"
          height="40"
          viewBox="0 0 120 120"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="aiDisconnected" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00e5ff" />
              <stop offset="100%" stopColor="#006eff" />
            </linearGradient>
            <linearGradient id="aiConnected" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFCCD2" />
              <stop offset="100%" stopColor="#C8102E" />
            </linearGradient>
            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
              <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g fill={fillColor} filter="url(#glow)">
            {bars.map((bar, i) => (
              <rect
                key={i}
                x={bar.x}
                y={bar.y}
                width="8"
                height={bar.height}
                rx="3"
              >
                {animating && (
                  <>
                    <animate
                      attributeName="height"
                      values={`0;${bar.height};0`}
                      dur={bar.dur}
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="y"
                      values={`60;${bar.y};60`}
                      dur={bar.dur}
                      repeatCount="indefinite"
                    />
                  </>
                )}
              </rect>
            ))}
          </g>
        </svg>
      </div>
      <div
        style={{ whiteSpace: "nowrap", fontFamily: "monospace", fontSize: 18 }}
      >
        Saxdor AI
      </div>
    </div>
  );
};

export default Visualizer;
